
export class ChangeDataModel {

  // 受注コード
  private _orderCode: string = null;
  // 生協コード
  private _coopCode: string = null;
  // Ｐコード
  private _pCode: string = null;
  // アイテムコード
  private _itemCode: string = null;
  // 媒体区分
  private _mediumType: string = null;
  // 予約詳細情報ID
  private _preOredeDetailId: string = null;
  // 企画予約商品利用生協情報
  private _preOrderCoopFlg: boolean = false;
  // 1物N価詳細情報ID
  private _nvalDetailId: string = null;
  // キーコード
  private _keyCode: string = null;
  // 変更項目（名称）
  private _changeItemName: string = null;
  // 変更項目（項番）
  private _changeItemNum: string = null;
  // 変更項目（指標）
  private _changeItemIndex: string = null;
  // 串刺指定
  private _skewerSelect: boolean = null;
  // 串刺選択ロック
  private _skewerSelectLock: string = null;
  // 変更前内容
  private _contentBeforeChange: string = null;
  // 変更後内容
  private _contentAfterChange: string = null;
  // 生協名（通称）
  private _aliasCoopName: string = null;

  public get orderCode(): string {
    return this._orderCode;
  }
  public get coopCode(): string {
    return this._coopCode;
  }
  public get pCode(): string {
    return this._pCode;
  }
  public get itemCode(): string {
    return this._itemCode;
  }
  public get mediumType(): string {
    return this._mediumType;
  }
  public get preOredeDetailId(): string {
    return this._preOredeDetailId;
  }
  public get keyCode(): string {
    return this._keyCode;
  }
  public get changeItemName(): string {
    return this._changeItemName;
  }
  public get changeItemNum(): string {
    return this._changeItemNum;
  }
  public get changeItemIndex(): string {
    return this._changeItemIndex;
  }
  public get skewerSelect(): boolean {
    return this._skewerSelect;
  }
  public get skewerSelectLock(): string {
    return this._skewerSelectLock;
  }
  public get contentBeforeChange(): string {
    return this._contentBeforeChange;
  }
  public get contentAfterChange(): string {
    return this._contentAfterChange;
  }
  public get aliasCoopName(): string {
    return this._aliasCoopName;
  }
  public set orderCode(order: string) {
    this._orderCode = order;
  }
  public set coopCode(coop: string) {
    this._coopCode = coop;
  }
  public set pCode(pCd: string) {
    this._pCode = pCd;
  }
  public set itemCode(item: string) {
    this._itemCode = item;
  }
  public set mediumType(medium: string) {
    this._mediumType = medium;
  }
  public set preOredeDetailId(preOredeDetailId: string) {
    this.preOredeDetailId = preOredeDetailId; 
  }
  public set keyCode(keyCode: string) {
    this._keyCode = keyCode; 
  }
  public set changeItemName(itemName: string) {
    this._changeItemName = itemName;
  }
  public set changeItemNum(itemNum: string) {
    this._changeItemNum = itemNum;
  }
  public set changeItemIndex(itemIndex: string) {
    this._changeItemIndex = itemIndex;
  }
  public set skewerSelect(skewer: boolean) {
    this._skewerSelect = skewer;
  }
  public set skewerSelectLock(skewerLock: string) {
    this._skewerSelectLock = skewerLock;
  }
  public set contentBeforeChange(contentBefore: string) {
    this._contentBeforeChange = contentBefore;
  }
  public set contentAfterChange(contentAfter: string) {
    this._contentAfterChange = contentAfter;
  }
  public set aliasCoopName(aliasCoopName: string) {
    this._aliasCoopName = aliasCoopName;
  }
  public setProperties(rowData: any, orderCode: string = <string>'', coopCode: string = <string>'',
    pCode: string = <string>'', itemCode: string = <string>'', mediumType: string = <string>'', preOredeDetailId: string = <string>'', preOrderCoopFlg: boolean = <boolean>false, nvalDetailId: string = <string>''): void {

    const tempRowData = rowData;
    this._orderCode = orderCode;
    this._coopCode = coopCode;
    this._pCode = pCode;
    this._itemCode = itemCode;
    this._mediumType = mediumType;
    this._preOredeDetailId = preOredeDetailId;
    this._preOrderCoopFlg = preOrderCoopFlg;
    this._nvalDetailId = nvalDetailId;

    if (tempRowData.KeyCode == null || tempRowData.KeyCode === 'null') {
      this._keyCode = '';
    } else {
      this._keyCode = tempRowData.KeyCode;
    }

    if (tempRowData.ChangeItemName === 'null') {
      this._changeItemName = '';
    } else {
      this._changeItemName = tempRowData.ChangeItemName;
    }

    this._changeItemNum = tempRowData.ChangeItemNum;
    this._changeItemIndex = tempRowData.ChangeItemIndex;
    this._skewerSelect = tempRowData.SkewerSelect === '1' ? true : false;
    this._skewerSelectLock = tempRowData.SkewerSelectLock;

    if (tempRowData.ContentBeforeChange === 'null') {
      this._contentBeforeChange = '';
    } else {
      this._contentBeforeChange = tempRowData.ContentBeforeChange;
    }

    if (tempRowData.ContentAfterChange === 'null') {
      this._contentAfterChange = '';
    } else {
      this._contentAfterChange = tempRowData.ContentAfterChange;
    }
  }
}
